<script>
import { mapGetters } from 'vuex';
import LoadIndicator from '../components/LoadIndicator';

export default {
    name: 'QuestionsPage',
    metaInfo() {
        return {
            title: this.$t('questionPage.seoTitle'),
            link: [
                { vmid: 'canonical', rel: 'canonical', href: this.$t('global.url') + window.location.pathname }
            ],
            meta: [
                { vmid: 'description', name: 'description', content: this.$t('questionPage.seoDescription') },
                { vmid: 'og:url', property: 'og:url', content: this.$t('global.url') + window.location.pathname },
                { vmid: 'og:title', property: 'og:title', content: this.$t('questionPage.seoOgTitle') },
                { vmid: 'og:description', property: 'og:description', content: this.$t('questionPage.seoOgDescription') },
            ],
        }
    },
    components: {
        LoadIndicator,
    },
    mounted() {
        this.$store.dispatch('loadAllQuestions');
        this.$store.dispatch('loadAllQuestionCategories');
        this.$store.dispatch('setSiteHeaderOpaque');
        this.$store.dispatch('showSiteFooter');
    },
    data() {
        return {
            routerTransitionName: 'fade',
        }
    },
    computed: {
        ...mapGetters({
            isLoading: 'getQuestionsIsLoading',
        }),
        routerKey() {
            return this.$route.path;
        },
    },
    beforeRouteUpdate(to, from, next) {
        if (from.path.includes(this.$t('contributorQuestions.path'))) {
            this.routerTransitionName = 'slide-right';
        } else if (to.path.split('/').length !== from.path.split('/').length) {
            this.routerTransitionName = to.path.split('/').length > from.path.split('/').length ? 'slide-left' : 'slide-right';
        } else {
            this.routerTransitionName = 'fade';
        }
        next();
    },
};
</script>

<template>
    <section class="questions-page">
        <div class="questions-page__loading" v-if="isLoading">
            <load-indicator />
        </div>
        <transition v-bind:name="routerTransitionName" mode="out-in">
            <router-view v-bind:key="routerKey" />
        </transition>
    </section>
</template>

<style lang="scss" scoped>
.questions-page__loading {
    @include container;
    @include page;
}
.fade-enter-active {
  transition: opacity 500ms;
}
.fade-leave-active {
  transition: opacity 200ms;
}
.fade-enter {
  opacity: 0;
}
.fade-leave-to {
  opacity: 0;
}

.slide-left-enter-active, .slide-left-leave-active,
.slide-right-enter-active, .slide-right-leave-active {
  transition: opacity 500ms, transform 500ms;
}
.slide-left-enter {
  opacity: 0;
  transform: translateX(20%);
}
.slide-left-leave-to {
  opacity: 0;
  transform: translateX(-20%);
}

.slide-right-enter {
  opacity: 0;
  transform: translateX(-20%);
}
.slide-right-leave-to {
  opacity: 0;
  transform: translateX(20%);
}
</style>
